import { useQuery } from '@tanstack/react-query';

import { msCatalystApi } from '../../services/api/ms-catalyst-api.js';

const fetchActiveCampaign = async () => {
  const { data: activeCampaign } = await msCatalystApi.get('campaigns/ongoing');
  if (!activeCampaign?.data) return null;
  return {
    ...activeCampaign?.data.campaign,
    shops: activeCampaign?.data.shops?.map((item) => item) || [],
  };
};

export function useQueryActiveCampaign() {
  return useQuery({
    queryKey: ['active_campaign'],
    queryFn: fetchActiveCampaign,
    refetchOnWindowFocus: false,
    retry: false,
    // staleTime: 100000,
    retryOnMount: false,
    // refetchOnMount: false,
  });
}
